import { createApp } from 'vue'
import App from './App.vue'
import './styles/main.less'

// import '@/styles/main.less'

createApp(App).mount('#app')